import { render, staticRenderFns } from "./CaseQuoteDetailRelated.vue?vue&type=template&id=7edd57c0&scoped=true&"
import script from "./CaseQuoteDetailRelated.vue?vue&type=script&lang=ts&"
export * from "./CaseQuoteDetailRelated.vue?vue&type=script&lang=ts&"
import style0 from "./CaseQuoteDetailRelated.vue?vue&type=style&index=0&id=7edd57c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edd57c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
